/**
 * @description This is a logger for internal usage
 * @please Use console for debugging
 *  From @tai BOSS
 */
export const logger = new Proxy(console, {})
